import React, { ReactElement } from "react";

import { LoginMainTitle } from "@/components/atoms/typograhies/LoginMainTitle";
import { LayoutLoginTemplate } from "@/components/templates/layout/Login";

const styles = {
  wrapper: "p-2 bg-theme-thin rounded-2xl md:p-4",
  inner:
    "py-4 px-2 space-y-6 md:space-y-10 bg-white rounded-2xl md:py-6 md:px-[13.75%]",
  section: "space-y-2",
  header: "font-bold",
};

export default function TermsIndex() {
  return (
    <article className="mx-auto max-w-[992px] md:pt-14">
      <LoginMainTitle title="利用規約" className="mb-11 text-center md:mb-6" />
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <section>
            <p>
              このYoyacoo利用規約（以下「本規約」といいます。）は、オーガニックスタイル株式会社（以下「弊社」といいます。）が運営する本サービス（第１条に規定します。）を利用する全てのお客様（以下「ユーザー」といいます。）及びユーザーになろうとするお客様に適用され、ユーザーと弊社の間の本サービス利用に関する一切の関係に適用されます。
              <br />
              本サービスを利用するユーザーは、利用することにより、本規約の全ての内容に同意したものとみなされます。本サービスの利用に際しては、本規約全文をお読みいただいた上、本規約に同意いただく必要があります。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第一章 総則</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１条 定義</h2>
            <p>
              1.
              「ユーザー」とは、第5条に定める方法により、本サービスの利用申込を行い、弊社によって利用申込を承諾された個人または法人のお客様をいいます。
              <br />
              2.
              「顧客」とは、ユーザー制作ページから情報を登録して、ユーザーのサービスを利用する又は利用しようとするユーザーのお客様をいいます。
              <br />
              3.
              「ユーザー制作ページ」とは、ユーザーが、弊社の提供する予約サービス等プラットフォームYoyacooを利用して制作した全てのサービスページをいいます。
              <br />
              4.
              「Yoyacoo」とは、弊社が「Yoyacoo」との名称（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）でユーザーに対して提供するプラットフォームでの予約受付サービス及びその他のサービスをいいます。
              <br />
              5.
              「ユーザー締結契約」とは、Yoyacooを利用してユーザーと顧客との間で締結されるユーザー提供サービスの利用に関する契約をいいます。
              <br />
              6.
              「クレジットカード決済」とは、ユーザーが本規約及び弊社所定の手続に従い、顧客が対象サービスの代金をクレジットカードで支払う形式により対象サービスを提供する方法をいいます。
              <br />
              7.
              「決済機能」とは、弊社が「決済機能」との名称（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）でユーザーに対して提供するクレジットカード決済によって、ユーザー締結契約の決済を行うサービスをいいます。その具体的な方法等については、第七章に定めるものとします。
              <br />
              8.
              「法令等」とは、法令、通達、指針、ガイドラインその他の司法上及び行政上の規制をいいます。
              <br />
              9.
              「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権、その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）をいいます。
              <br />
              10. 「本サービス」とは、弊社が提供する「
              <a href="https://yoyacoo.jp">https://yoyacoo.jp</a>
              」のドメイン名（当該ドメインが変更された場合は、変更後のドメインを含みます。）、これらのサブドメイン名を介して提供する予約サービス、アンケート、コンテンツ提供その他のあらゆるクラウドサービスをいいます。
              <br />
              11.
              「本API」とは、決済機能を提供するためのアプリケーションプログラミングインターフェイスをいいます。
              <br />
              12.
              「予約サービス機能」とは、弊社が提供するユーザー制作ページにおいて、ユーザーが顧客からのオンライン予約を受け付けるための機能及びそれに付随するサービスをいいます。
              <br />
              13.
              「メール配信機能」とは、弊社がユーザーに対して提供する、ユーザーがメールマガジン又はお知らせ等のメールを、当該メールの配信を希望する顧客に対して配信する機能及びそれに付随するサービスを言います。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２条 本規約の追加ないし変更</h2>
            <p>
              弊社は、ユーザーの承諾を得ることなく、本規約の内容を、いつでも追加ないし変更することができるものとします。尚、追加または変更した場合、すみやかにユーザーから届出のあった通知先（メールアドレスないし登録されたユーザーの連絡先）に対してその内容を通知し、インターネット上のYoyacooのウェブサイトに変更後の規約をアップロードするものとします。その場合、通知の際に定める一週間以上の相当な期間を経過した日を効力発生時期として、適用されるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３条 本サービスの内容</h2>
            <p>
              1. 本サービスは、弊社のウェブサイトに掲載された「
              <a href="https://yoyacoo.jp">https://yoyacoo.jp</a>
              」のドメイン名（当該ドメインが変更された場合は、変更後のドメインを含みます。）及びこれらのサブドメイン名を介して提供する、予約受付、アンケート、サブスクリプション提供、コンテンツ提供等の全てのクラウドサービスとなります。
              <br />
              2.
              本サービスにおける各プラン毎に提供される機能の内容及び料金等は、弊社が「
              <a href="https://yoyacoo.jp/index.html#priceSec">
                Yoyacoo料金プラン一覧表
              </a>
              」に別途定める通りとします。
              <br />
              3.
              ユーザーは、本サービスを利用することで、顧客から、各種サービスや役務の提供に関する問い合わせ及び購入・利用の申込みを受付けることができます。その際、ユーザーは、顧客に対し、自己の責任において連絡・対応し、申込みを承諾する場合には、サービスや役務提供等を履行し、そのために必要な手続を行うものとします。
              <br />
              4.
              弊社は、ユーザーが本サービスを利用する際に、顧客の実在、権利能力及び行為能力の保有、契約締結権限の保有、ユーザーと顧客の間のトラブルが生じないこと等につき保証するものではありません。これらについては、すべてユーザーの責任となります。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第４条 本サービスの内容及び利用条件の変更
            </h2>
            <p>
              弊社は、本サービスで提供する機能の内容及び利用料金等の利用条件（以下「本利用条件」といいます。）を、いつでも変更することができるものとします。
              <br />
              その変更に際しては、変更前にユーザーに対して通知し、ユーザーが変更期日までに、第34条に基づく利用契約の解約を申し出なかった場合、ユーザーは、当該利用条件の変更に同意したものとみなします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第二章 利用契約締結</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第５条 利用契約の申込みと成立</h2>
            <p>
              1.
              本サービスの利用を希望する者は、弊社所定の登録手続（以下「アカウント登録」といいます。）に従って、利用契約を申込むものとし、その申込みをもって、本規約を遵守することに同意したものとみなします。
              <br />
              2.
              本サービスの利用に関する弊社とユーザーの間の契約（以下「利用契約」といいます。）は、弊社がその申込みを承諾した時に成立するものとします。
              <br />
              3.
              弊社は、ユーザーとなろうとする者が実在しない場合や利用申込みに虚偽の内容があった場合等、利用申込を承諾しないことが相当であると判断した場合、利用申込を承諾しないことがあります。その場合、弊社は、利用申込を承諾しない理由を開示する義務を負わないものとします。
              <br />
              4.
              ユーザーになろうとするお客様が未成年者であり、本サービスのうち有償のものの利用申込をする場合には、法定代理人の同意を得た上でこれを行うものとし、当該ユーザーになろうとするお客様は、法定代理人の同意を得ていることを表明、保証するものとします。本規約の利用申込時に未成年であったお客様が成年に達した後に本サービスを利用した場合、本規約に関する一切の法律行為を追認したものとみなされます。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第６条 ユーザー情報の管理及び提供</h2>
            <p>
              1.
              ユーザーは、アカウント登録により利用契約を申し込む際、ユーザー情報を虚偽なく正確に入力し、登録するメールアドレスは、日常的に受信内容を確認できるものとします。そして、IDやパスワードなどの登録した情報を、自己の責任で管理するものとします。かかる管理には、パスワードの複雑化、定期的なパスワード等の変更、その他パスワード等の漏洩防止を含みます。
              <br />
              2.
              ユーザー情報の紛失等によりアカウントの利用ができなくなった場合や、漏洩により第三者の利用が生じ当該ユーザーに損害が生じた場合であっても、弊社は一切の責任を負わないものとします。また、万が一、ユーザー情報が漏洩した場合や第三者に当該ユーザーのアカウントが利用され、又は乗っ取り等にあったと確認された場合、当該ユーザーは速やかに弊社に連絡し弊社担当者の指示に従うものとします。その際、その問題によって他のユーザーに混乱等が生じると弊社が判断した場合、弊社は、事前の通知等なく当該アカウントを凍結、停止又は削除できるものとし、それにより生じるユーザーの損害については、一切の責任を負わないものとします。
              <br />
              3.
              ユーザーは、弊社から本サービスの提供に必要な資料、情報等の提供や対応を求められた場合には、速やかにこれに応じるものとします。尚、ユーザーがかかる資料、情報等の提供その他対応を怠ったことに起因して、弊社が本サービスを提供することができなかった場合でも、弊社は一切の責任を負わないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第７条 本サービス利用情報等の取り扱い
            </h2>
            <p>
              1.
              ユーザー及び顧客の登録情報、端末情報等その他本サービスの利用に関する情報（ユーザーID、登録名称、メールアドレス、弊社との契約情報、ユーザー制作ページに関する取扱商品、注文履歴、取引履歴、決済に関する履歴、並びに弊社への問い合わせ情報を含み、これらを総称し「本サービス利用情報等」といいます）の取り扱いについては、弊社が別途定める「
              <a href="https://yoyacoo.jp/user/privacy">プライバシーポリシー</a>
              」によるものとし、ユーザーは、当該プライバシーポリシーに従って、弊社が当該情報を取り扱うことを同意するものとします。
              <br />
              2.
              弊社は、本サービス利用者情報等を、弊社の裁量により、本サービスの提供及び運用、サービス内容の改良及び向上、並びにこれに付随する業務等の目的のために利用し、又は、個人を特定できない形での統計的情報として公開することができるものとし、ユーザーは、これに同意するものとします。
              <br />
              3.
              弊社は、本サービスの利用状況を把握するため（リターゲティング広告配信の目的を含みます。）、Cookie又は情報収集モジュールを利用して、本サービス利用情報等を収集することがあります。尚、弊社はCookie及び情報収集モジュールを利用することによって生じた損害については、責任を負わないものとし、ユーザーは、あらかじめこのことを承諾するものとします。
              <br />
              4.
              弊社は、本サービスの利用者情報を運営上保存していた場合であっても、かかる情報の保存義務を負わないものとし、いつでも弊社の裁量により、その情報を削除することができるものとします。その削除により、ユーザーに損害が生じた場合であっても、弊社は一切の責任を負わないものとします。
              <br />
              5.
              弊社は、顧客又は第三者機関等から情報提供の要請があった場合で、かつ、弊社が情報提供の必要性を認めた場合、ユーザーに事前又は事後の通知なく、当該顧客又は第三者機関等に対し、ユーザーに関連する情報の提供等を行う場合があります。尚、個人情報については、法令で許容される場合に限り、これを行うものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第８条 届出事項の変更</h2>
            <p>
              ユーザーの名称（氏名）、連絡先（メールアドレス）、その他アカウント登録時に入力した項目について変更があった場合、ユーザーは、すみやかにその旨を届け出るものとします。これを怠ったことにより、ユーザーが損害を被ったとしても、弊社は責任を負わないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第三章 ユーザーの義務</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第９条 規約遵守</h2>
            <p>
              ユーザーは、本サービス利用に際し、本規約の他、本サービスに関連するすべての規定及び弊社からの通知に従うものとします。弊社がYoyacooに関して別途定めるガイドライン、ヘルプ、その他の規定及び通知は、本規約の一部を構成しますが、本規約とそれらの内容が異なっている場合は、本規約が優先して適用されます。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第１０条 有料プランの利用料及び支払い
            </h2>
            <p>
              1.
              有料プランのユーザーは、利用料を弊社に支払うものとし、その利用料は、ユーザーによる本予約サービス利用の有無にかかわらず、有料サービス契約成立の日から発生するものとします。
              <br />
              2. 有料プランの利用料は、ユーザーが弊社に対し、「
              <a href="https://yoyacoo.jp/index.html#priceSec">
                Yoyacoo料金プラン一覧表
              </a>
              」の記載及び第24条の規定に従って支払うものとします。尚、支払い済みの利用料については、返金しないものとします。
              <br />
              3.
              ユーザーが、名目の如何を問わず本サービスの利用にかかる料金の支払いを遅滞した場合、ユーザーは、年14.6%の遅延損害金を弊社に支払うものとします。
              <br />
              4.
              弊社は、有料サービス利用料の価格を変更することができるものとします。その場合、弊社は、ユーザーに対し、変更後の価格を事前に告知するものとし、ユーザーが所定の期間内に解約手続を行わない場合、当該変更後の価格にユーザーが同意したものとみなします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１１条 環境設定</h2>
            <p>
              1.
              ユーザーは、本サービスの利用に際し、必要な通信環境、ハードウェア及びソフトウェアを、自己の責任で準備して本サービスを利用するものとし、その利用に伴う通信費用を負担するものとします。
              <br />
              2.
              弊社は、ユーザーが本サービスを利用するために必要となるネットワーク通信環境について、なんら保証しません。
              <br />
              3.
              ユーザーは、ユーザー制作ページのコンテンツ等については、自らの責任で管理、保存、バックアップ等の対策を講じるものとし、弊社は、これらに関し、一切責任を負わないものとします。
              <br />
              4.
              ユーザーが、弊社の設備または本サービスの不具合を発見した場合、弊社にその旨を通知し、当該不具合の対応ないし復旧を求めるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１２条 禁止事項</h2>
            <p>
              弊社は、本サービスの利用について、ユーザーが、自ら又は第三者をして、下記各号の行為（これらの行為を直接又は間接に惹起し、又は容易にする行為を含みます。）をすることを禁止します。
              <br />
              1.
              本規約及び本サービスのために弊社が提携する企業の規約等に違反し、又はそのおそれのある行為。
              <br />
              2. 関連法規に反する営業行為ないし行政指導に反する営業行為。
              <br />
              3.
              法令または公序良俗に反し、またはそのおそれのある行為。これらを助長する行為。
              <br />
              4. 本サービスを不正に利用し、又はそのおそれがある行為。
              <br />
              5.
              本サービスの通常の使用目的以外で本サービスを利用し、又はそのおそれがある行為。
              <br />
              6.
              本サービスとは関連性がない又は関連性が著しく小さいと弊社が判断するサービス、宗教、団体、活動への勧誘。
              <br />
              7. 他のユーザーの迷惑になる行為、又はそのおそれがある行為。
              <br />
              8.
              弊社及び他のユーザー、第三者が不利益を被る行為、又はそのおそれのある行為。
              <br />
              9.
              弊社及び他のユーザー、第三者の知的財産権、財産、プライバシー（自己の情報をみだりに公開されない権利、生活の平穏を保持する権利及び肖像権その他プライバシーに係るあらゆる権利を含む）を侵害する行為、又はそのおそれのある行為。
              <br />
              10.
              弊社及び他のユーザー、第三者を誹謗中傷し、若しくは名誉ないし信用を毀損する行為、又はそのおそれのある行為。
              <br />
              11.
              他のユーザー及び第三者の個人情報や機密情報を本人の事前の同意なく不正な手段をもって取得する行為、若しくは公開する行為、又はそのおそれのある行為。
              <br />
              12.
              顧客に関する本サービス利用情報等の収集をする行為、又はそのおそれのある行為。
              <br />
              13.
              公序良俗に反する行為、又はそのおそれのある行為、または公序良俗に反する情報を他のユーザーや顧客に提供する行為。
              <br />
              14.
              性的な表現や暴力的ないし差別につながる表現、その他不適切と認める表現を掲載し、又はそのおそれのある行為やそれらを促す行為。
              <br />
              15.
              ねずみ講、マルチ商法その他違法・不当な取引に当たると弊社が合理的に判断する内容を掲載・勧誘する行為。
              <br />
              16.
              本サービスのシステムやソースの改ざん、本サービスのサーバー等へのアタック、コンピューターウィルス等による本サービスへの妨害、及び他のユーザーやその他の第三者の不利益になる行為、又はそのおそれのある行為。
              <br />
              17.
              本サービスのネットワーク若しくはシステム等に過度な負荷をかける行為、又はそれらのおそれのある行為。
              <br />
              18.
              本サービに関し、内容の如何を問わず、利用可能な情報を漏洩もしくは改ざんする行為。
              <br />
              19.
              本サービスの全部ないし一部を、許可なく複製、複写、転載等により本来の利用目的を超えて利用する行為。
              <br />
              20.
              弊社の本サービスの運用、及び外部サービスを運営する企業の運用等を妨害する行為、又はそのおそれのある行為。
              <br />
              21.
              他人になりすますこと（他人のアカウントの利用を含みますがこれに限られません）その他の詐欺行為、又はそのおそれのある行為。
              <br />
              22.
              他のユーザーのユーザー情報を盗み取る行為、その情報を悪用する行為、若しくはユーザー情報を改ざんする行為、又はそれらのおそれのある行為。
              <br />
              23.
              IPアドレス、アカウント、ログインID、パスワード、Eメールアドレス、及びドメイン名を不正に取得、使用、譲渡または貸与する行為。
              <br />
              24.
              サービス料等の弊社からの請求に対して、弊社への支払いを遅延若しくは滞納する行為。
              <br />
              25. 反社会的勢力への利益供与をする行為、又はそのおそれのある行為。
              <br />
              26. その他、弊社が本サービスの利用上不適切であると判断する行為。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１３条 個人情報の管理</h2>
            <p>
              1.
              ユーザーは、本サービスを使用して取得した顧客その他の個人の個人情報について、個人情報取扱事業者として適切に管理し、三者による取得、漏洩等の発生防止の措置を講じるものとします。尚、ユーザーは、上記個人からの個人情報の開示、訂正、利用停止、消去等の請求に対しては、自己の責任でこれに対応するものとします。
              <br />
              2.
              前項の他、ユーザーは、個人情報保護法を遵守し、偽りその他不正の手段によって取得した個人情報を、本サービスにおいて使用しないものとします。
              <br />
              3.
              弊社は、ユーザーから個人情報の保護に関する法律（平成15年法律第57条）に定める個人データの取り扱いの全部又は一部の委託を受けるものではありません。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１４条 バックアップ</h2>
            <p>
              1.
              弊社は、本サービスの提供に際して取得したユーザーの個人情報を、弊社の「
              <a href="https://yoyacoo.jp/user/privacy">プライバシーポリシー</a>
              」に基づき取り扱うものとし、ユーザーは、これに同意するものとします。
              <br />
              2. 弊社は、個人情報保護法を遵守するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第四章 弊社の義務</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１５条 維持責任</h2>
            <p>
              弊社は、本サービスの品質につき、少なくとも、本サービス提供開始時の技術標準を前提として維持するべく合理的に務めるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１６条 個人情報の取り扱い</h2>
            <p>
              1.
              弊社は、本サービスの提供に際して取得したユーザーの個人情報を、弊社の「
              <a href="https://yoyacoo.jp/user/privacy">プライバシーポリシー</a>
              」に基づき取り扱うものとし、ユーザーは、これに同意するものとします。
              <br />
              2. 弊社は、個人情報保護法を遵守するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第五章 本サービスの中断・停止</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１７条 本サービスの中断</h2>
            <p>
              1.
              弊社は、次の各号のいずれかに該当する場合に、本サービスの提供を中断することがあります。
              <br />
              &nbsp;1)
              本サービス提供に必要なシステムサーバー等の設備の一部もしくは全部について、システム拡張、メンテナンス等を行うためこれらを停止させる場合
              <br />
              &nbsp;2)
              本サービス提供に必要なシステムやサーバー等の障害を補修する場合
              <br />
              &nbsp;3)
              第三者から不正アクセスを受けた場合等、弊社が本サービスを中断する合理的理由が認められるものと判断した場合
              <br />
              &nbsp;4)
              天変地異等の非常事態が発生し、又は発生するおそれがある場合
              <br />
              &nbsp;5)
              弊社が利用する電気通信設備の障害等、やむを得ない事由が発生した場合
              <br />
              &nbsp;6) 電気通信事業者が電気通信役務の提供を停止した場合
              <br />
              &nbsp;7)
              その他、弊社が本サービスの提供の全部または一部を中止する必要があると判断した場合
            </p>
            <p>
              2.
              前項の本サービス提供の中断により、ユーザー及び第三者に損害が発生したとしても、弊社は一切その責任を負いません。
            </p>
            <p>
              3.
              第1項の規定に基づき本サービスの提供を中断する場合、弊社は、原則として、あらかじめ、その理由ないし提供を中断する日時及び期間を、ユーザーに通知するものとします。ただし、緊急その他やむを得ない事情がある場合は、この限りではないものとします
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１８条 本サービスの停止</h2>
            <p>
              1.
              弊社は、ユーザーが次の各号のいずれかに該当する場合は、本サービスの提供の全部または一部を停止することがあります。
              <br />
              &nbsp;1) 第12条（禁止事項）に定める行為を行った場合
              <br />
              &nbsp;2) 利用料金を指定の期日に支払わない場合
              <br />
              &nbsp;3)
              本規約に違反し、その違反状態を是正するよう催告されたにもかかわらず、定められた期限までに違反状態を解消できない場合
              <br />
              &nbsp;4) 弊社が不適切だと判断する行為を行った場合
            </p>
            <p>
              2.
              前項の本サービス提供の停止により、ユーザー及び第三者に損害が発生したとしても、弊社は一切その責任を負いません。
            </p>
            <p>
              3.
              第１項の規定に基づき本サービスの提供を停止する場合、弊社は、その判断に関する理由を開示する義務は負いません。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第六章 決済機能</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１９条 決済機能の提供</h2>
            <p>
              1.
              本サービスの決済機能は、下記決済代行サービス提供会社による機能を使用して提供されます。ストライプジャパン株式会社
              以下「stripe」とします。（「
              <a href="https://stripe.com/jp">https://stripe.com/jp</a>」）
              <br />
              2.
              決済機能を利用することを希望するユーザー又はユーザーになろうとするお客様は、弊社所定の利用申込（第5条における本サービスの利用申込と同時の場合を含みます）を行い、決済代行サービス提供会社と直接契約（アカウントの開設）をすることによって、本サービスの決済機能を利用することが可能となります。よって、決済機能をご利用になるユーザーは、連携する決済代行サービス提供会社の利用規約に同意の上、決済代行サービス提供会社にアカウントを作成して利用を開始するものとします。
              <br />
              3.
              弊社は、ユーザー又はユーザーとなろうとするお客様と決済代行サービス提供会社の契約に関し、直接的に関与することはございません。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２０条 ユーザーの調査・管理等</h2>
            <p>
              1.
              弊社は、必要と認める場合に、免許証等の身分証明書による本人確認をはじめ、ユーザーの法令等及び契約遵守状況その他ユーザーとしての適切性に関して調査を行うものとし、ユーザーは当該調査に全面的に協力するものとします。
              <br />
              2.
              弊社は、前項の調査の結果、ユーザーが弊社の定める基準に適合しないと判断した場合には、決済機能の全部又は一部の利用の一時停止若しくは制限（振込申請の制限を含むがこれに限られません。）、アカウントの削除等の措置をとることができるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２１条 本APIの利用</h2>
            <p>
              1.
              ユーザーは、決済機能の利用資格が有効に存続する期間に限り、本規約の目的の範囲内でかつ本規約に違反しない範囲内で、弊社所定の方法に従って、本APIを利用することができます。
              <br />
              2.
              ユーザーは、本APIの提供を受けるため及びこれを利用するために必要なコンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持を、自己の費用と責任において行うものとします。
              <br />
              3.
              ユーザーは、自己の本APIの利用環境に応じて、コンピューターウィルスの感染の防止、不正アクセス及び情報漏洩の防止等、必要なセキュリティ対策を自己の費用と責任において講じるものとします。
              <br />
              4.
              弊社が、本APIが全てのソフトウェアに対応していることを保証するものではないこと、並びに、バージョンアップ等に伴い本APIの動作に不具合が生じる可能性があることにつき、ユーザーは予め了承するものとします。弊社は、かかる不具合が生じた場合に弊社が行うプログラムの修正等により当該不具合が解消されることを保証するものではありません。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２２条 ユーザーの義務及び責任</h2>
            <p>
              1.
              ユーザーは、本APIについて、再使用許諾、貸与その他一切の処分をしてはならないものとします。
              <br />
              2.
              ユーザーは、本APIの利用その他本サービスに関して、弊社から報告を求められたときは、いつでも弊社の指定する方法に従って報告を行わなければならないものとします。ユーザーは、かかる報告をするにあたって、資料等の提出を求められたときは、資料等を提出しなければならないものとします。
              <br />
              3.
              ユーザーは、前項の報告及び資料等の提出を行うにあたり、虚偽の事実、資料等を報告、提供してはならないものとします。
              <br />
              4.
              ユーザーは、決済機能を使用した顧客から決済手続に関する苦情、問い合わせを受けた場合には、直ちに、弊社に報告しなければならないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第２３条 本サービス利用情報等の取り扱い
            </h2>
            <p>
              決済機能を利用する場合の本サービス利用情報等の取扱いについては、第７条の規定を準用するものとします。この場合、第7条第1項において「弊社」とあるのは「弊社又は決済代行サービス提供者」と読み替えて適用するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第七章 料金及び決済</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２４条 総則</h2>
            <p>
              ユーザーは、弊社に対し、本サービスの有料プラン利用料を第25条に定める通り支払うものとします。
              また、Yoyacoo決済機能を利用したユーザー利用契約の支払処理サービスについては、決済代行サービス会社Stripeが主体となって直接提供するので、ユーザーは、Stripe社による「
              <a href="https://stripe.com/jp/legal/connect-account">
                Stripe Connect アカウント契約
              </a>
              」に従うものとします。ユーザーは、本規約への同意または本サービスにおいてユーザーとして取引を継続することにより、同契約（「
              <a href="https://stripe.com/jp/legal/ssa">stripe利用規約</a>
              」を含みます。これはStripeによりいつでも修正されることがあり、修正後の内容も含みます。）に拘束されることに同意するものとします。このStripeを通じた決済機能及び支払処理サービスを利用できるための条件として、ユーザーは、本サービスに対して、ユーザー及びユーザーの事業に関する正確かつ漏れのない情報を提供することに同意し、本サービスが当該情報及びStripeが提供する支払処理サービスのユーザーによる使用に関連する取引情報を共有することを認めるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２５条 有料プラン利用料</h2>
            <p>
              1. 年払契約（12ヶ月分のプラン利用料を一括で支払う契約）
              <br />
              &nbsp;1) 年払契約の支払金額は、弊社「
              <a href="https://yoyacoo.jp/index.html#priceSec">
                Yoyacoo料金プラン一覧表
              </a>
              」に記載した金額とします。
              <br />
              &nbsp;2) 支払方法・支払時期
              <br />
              &nbsp;ユーザーは、弊社に対し、クレジットカード払いの場合はプラン利用開始の当日（利用契約更新時には更新日の当日）に、１年分のプラン利用料を支払うものとします。
              <br />
              &nbsp;3) 契約期間
              <br />
              &nbsp;契約期間は、ユーザーによるプラン利用開始日（または更新日）すなわち利用契約成立日から１年間とします。
            </p>
            <p>
              2. 月払契約（プラン利用料を毎月支払う契約）
              <br />
              &nbsp;1) 月払契約の支払金額は、弊社「
              <a href="https://yoyacoo.jp/index.html#priceSec">
                Yoyacoo料金プラン一覧表
              </a>
              」に記載した金額とします。
              <br />
              &nbsp;2) 支払方法・支払時期
              <br />
              &nbsp;ユーザーは、弊社に対し、クレジットカード払いの場合は、プラン利用開始日の当日（利用契約更新時には更新日の当日）に、1ヶ月分のプラン利用料を支払うものとします。
              <br />
              &nbsp;3) 契約期間
              <br />
              &nbsp;契約期間は、ユーザーによるプラン利用開始日（または更新日）すなわち利用契約成立日から１ヶ月とします。更新日の前日までに、プランの変更又は解約を申請しない場合、それまでの料金プランが自動的に更新され、更新日の当日から、本サービス内に記載した料金の支払義務が発生するものとします。
            </p>
            <p>
              3. 解約手続
              <br />
              &nbsp;1)
              ユーザーが有料プラン契約の解約を申し入れる場合、解約期限（クレジットカード払いの場合は、契約期間最終日（更新日の前日）とします。以下、解約期限はすべて同様です。）までに、弊社所定の方法によって弊社に通知することとします。
              <br />
              &nbsp;2)
              ユーザーが、解約期限日までに解約を通知しなかった場合、ユーザーの有料プラン契約は、同一期間にて自動更新され、ユーザーは、翌契約期間分の有料プラン利用料支払義務を負うこととなります。
              <br />
              &nbsp;3)
              契約期間満了前に解約が行われた場合であっても、残存期間分の日割りでの精算・返金は行われません。
            </p>
            <p>
              4. その他
              <br />
              &nbsp;1)
              クレジットカードの課金処理ができなかった場合、次回に繰り越して課金処理を行います。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２６条 決済関連手数料</h2>
            <p>
              ユーザーは、Yoyacooの決済機能を利用する際、「
              <a href="https://yoyacoo.jp/index.html#priceSec">
                Yoyacoo料金プラン一覧表
              </a>
              」に記載の決済手数料及び振込手数料を支払うものとします。尚、決済手数料には、弊社が収受する手数料とStripeが収受する手数料が含まれます。また、振込手数料は、Stripeからユーザーに振り込む際にかかる手数料です。これらの手数料は予告なく変更される場合があります
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２７条 売上金額の支払等</h2>
            <p>
              1. 「<a href="https://stripe.com/jp/legal/ssa">Stripe利用規約</a>
              」にかかわらず、Stripeは、ユーザーに対し、毎月1日から末日までの間に発生した予約サービスの提供代金や月謝形式等の売上金額（消費税相当額を含みます。以下「売上金額」とします）の合計から、前項の決済関連手数料を含む決済処理関連費用（決済手数料、決済システム利用料、振込手数料、返金手数料、チャージバックの発生にかかる手数料を含む）を差し引いた金額を、翌月28日（同日が非営業日の場合は、翌営業日）までに、ユーザーが本サービス上で指定した銀行口座（以下「登録銀行口座」といいます）に振り込む手続を行います。（日本標準時）
              <br />
              2.
              ユーザーは、ユーザーと顧客の間の対象サービス利用に関する契約が、毎月一定日に自動的に更新され、契約更新時（ただし、初回は契約締結時）に対象サービスの予約代金の支払義務が発生する形式（以下「月謝形式」とします）により、対象サービスを提供することができます。
              <br />
              3.
              ユーザーが、登録銀行口座を登録していない場合や、登録銀行口座が無効の場合、又は、決済機能の利用審査や支払いにあたって追加情報請求がされている場合には、当該情報の登録を弊社が確認するまで、売上金額の振込手続きは行われないものとします。また、弊社は、予約キャンセルのリスク、チャージバックリスクその他諸般の事情を考慮し、弊社の合理的判断に基づき、売上金額の支払いを一時中止することができるものとします。そして、ユーザーが本サービス上で登録した支払いに関する情報に誤りがあり、それによって、売上金額の受取が遅延した場合や損害が発生した場合であっても、弊社に故意又は重過失がある場合を除き、弊社は責任を負いません。
              <br />
              4.
              弊社は、ユーザーの承諾を得ることなしに、予告なく手数料を改定する場合があり、ユーザーは、これに同意するものとします。また、改訂後の料金については、弊社が定める日から適用されるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第２８条 対象サービスの中止及び変更等
            </h2>
            <p>
              1.
              ユーザーは、自らの都合によって対象サービスを中止する場合、弊社所定の方法にしたがって、当該対象サービスにかかる予約のキャンセル手続を行うものとします。予約代金を既に支払い済みの予約者に対しては、決済代行サービス会社からユーザーに支払処理を行う前であれば、各クレジットカード会社ないし銀行等を介して弊社所定の方法で弊社が予約代金を返金するものとし、決済代行サービス会社からユーザーに支払処理が行われた後であれば、ユーザーが予約代金を返金するものとします。かかる返金に際しユーザーは、自ら設定したキャンセルポリシーに従い、予約代金からキャンセル料のみを差し引いた残りの金額を顧客へ返金するものとし、クレジットカード決済においてstripeに支払い済みの決済手数料についてはユーザーの負担となります。
              <br />
              2.
              ユーザーは、対象サービスに変更や瑕疵があった場合には、当該対象サービスを予約した顧客にすみやかにその事実を通知するものとします。
              <br />
              3.
              ユーザーは、対象サービスの質を維持するものとし、その品質が損なわれる可能性があるときには、すみやかに決済機能を無効とするか対象サービスを非公開にするものとします。
              <br />
              4.
              ユーザーは、予約者から対象サービスの瑕疵、債務不履行等の理由により予約代金の返還請求があった場合、自らの責任ですみやかにこれに対応するものとします。
              <br />
              5.
              クレジットカードのチャージバック（クレジットカード不正利用や詐欺、認知しないクレジットカードの利用、ユーザーの返金処理の未実施、重複予約を含みます。他の規定においても同様）が発生した場合、ユーザーは、チャージバック発生による手数料及び代行手数料を弊社に支払います。
              <br />
              6.
              チャージバックの発生により手数料が発生し、これを、売上金額から控除することができない場合、ユーザーは、弊社所定の手続により、遅滞なく当該手数料を支払うものとします。弊社は、当該手数料の支払いが完了するまで、ユーザーによる本サービスの利用停止その他必要と認められる措置を事前の通知なく弊社の合理的な判断に基づき行うことができるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２９条 紛争処理等</h2>
            <p>
              1.
              予約代金の返還請求について紛争が生じた場合には、ユーザーは、自らの責任で当該顧客と紛争を解決するものとします。予約代金の返還請求について、ユーザーに損害が発生した場合であっても、弊社はいかなる責任も負わないものとします。
              <br />
              2.
              クレジットカードのチャージバックが発生したことによる損害及びその他予約者からの代金回収不能による損害は、ユーザーが負担するものとし、弊社に故意又は重過失がある場合を除き、弊社は一切これを負担しないものとします。
              <br />
              3.
              弊社の判断により、決済機能は、予告なく停止・中断する場合があります。決済機能の停止・中断によりユーザーに損害が発生した場合であっても、弊社に故意又は重過失がある場合を除き、弊社はいかなる責任も負わないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第八章 一般条項</h2>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３０条 知的財産権等</h2>
            <p>
              1.
              Yoyacooのウェブサイト及び本サービスに関する知的財産権は、全て弊社または弊社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、弊社のYoyacooウェブサイトまたは本サービスに関する弊社または弊社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
              <br />
              2.
              ユーザーは、本サービスを通じて提供するいかなる情報についても、適法な権利を有していること、及び第三者の権利（知的財産権、肖像検討を含みますがこれらに限りません）、営業秘密またはプライバシーその他の権利を侵害していないことを、弊社に対し表明し、保証するものとします。
              <br />
              3.
              本条第１項及び第２項に関し、ユーザーと他のユーザーないし第三者との間で問題や紛争が生じた場合、ユーザーは、自らの費用と責任において、当該問題・紛争を解決し、弊社に何らの迷惑または存在を与えないものとします。
              <br />
              4.
              ユーザーは、本サービスに関し、リバースエンジニアリング、逆コンパイル、又は逆アセンブラ、その他本サービスを解析しようと試みてはならないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３１条 反社会的勢力等の排除</h2>
            <p>
              1.
              弊社及びユーザーは、現在、暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼう頃または特殊知能暴力集団等、その他これらに準ずる者（以下「反社会的勢力」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、保証します。
              <br />
              &nbsp;1)
              自己及び自己の役員が、自己の不当な利得その他目的の如何を問わずに、反社会的勢力の威力等を利用していると認められる関係を有すること
              <br />
              &nbsp;2)
              自己及び自己の役員が反社会的勢力に対して資金を提供し、便宜を供与するなど、反社会的勢力の維持運営に協力していると認められる関係を有すること
              <br />
              &nbsp;3)
              自己及び自己の役員が反社会的勢力と社会的に非難される関係を有すること
            </p>
            <p>
              2.
              弊社及びユーザーは、自己及び自己の役員が、自ら又は第三者を利用して、相手方に対して暴力的な要求行為、法的責任を超えた不当な要求行為、相手方の名誉や信用を毀損する行為、相手方の業務を妨害すること行為、その他それらに準ずる行為を行わないことを確約します。
            </p>
            <p>
              3.
              弊社又はユーザーは、相手方が、本条第１項各号ないし前項に違反していると合理的に判断した場合、何らの通知催告を要せず、直ちに本契約の全部又は一部を解除することができるものとします。
            </p>
            <p>
              4.
              弊社又はユーザーは、相手方が本条の規定に違反したことにより損害を被った場合、相手方に対し、前項に基づく契約解除にかかわらず当該損害について本契約に基づく損害賠償を請求できるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３２条 免責事項</h2>
            <p>
              弊社は、次の各号に該当する事項に関し、一切の責任を負わないものとします。尚、これらの問題によりユーザーが不利益を被ったとしても、ユーザーは、弊社に対し、一切の賠償請求を行わないことに同意するものとします。
              尚、ユーザーに生じた紛争の相手方等が、弊社に対してその問題に関する損害賠償請求を行い、やむを得ず弊社の判断でこれを支払った場合、弊社はユーザーに対し、賠償金額及び裁判になった場合の裁判費用、その他当該問題解決のために必要となった人権費その他の全ての費用を請求できるものとします。
              <br />
              &nbsp;1)
              ユーザーとユーザーのサービスを利用した顧客との間に生じた一切の問題
              <br />
              &nbsp;2)
              本サービス提供におけるシステムの不具合、エラーや障害、あるいは第三者によるハッキング等の本サービスに対する一切の妨害行為に起因し、又はそれに類する事情により本サービスの全部又は一部が利用不能もしくは機能不全に陥った場合に生じた一切の問題
              <br />
              &nbsp;3)
              通常講ずるべきウイルス対策では防止することのできないウイルス被害、天変地異、ストライキ、暴動、戦争、テロ行為等による被害、電力・通信サービス等社会インフラの停止その他当社の責めによらぬ事情に基づいて本サービスの全部又は一部の利用が不能又は機能不全となった場合に生じた一切の問題
              <br />
              &nbsp;4)
              提携する外部サービスの提供元のシステム障害やバージョンアップによる不具合その他第三者に起因する全ての問題
              <br />
              &nbsp;5)
              通信回線、ソフトウェア、ハードウェアなどのパフォーマンスの低下、障害、不正アクセス等により、Yoyacooサービスのシステムの中断・遅延・中止等によって生じた一切の問題
              <br />
              &nbsp;6)
              本サービス提供のための装置、システムの保守又は点検を行う際の停止により生じた一切の問題
              <br />
              &nbsp;7)
              他のユーザーの行為に起因して本サービスの全部又は一部の利用が不能又は機能不全に陥った場合に生じた一切の問題
              <br />
              &nbsp;8)
              本サービスの内容及びユーザーが本サービスを通じて得る情報等の完全性、正確性、確実性、有用性
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３３条 権利義務譲渡禁止</h2>
            <p>
              1.
              ユーザーは、利用契約に基づく権利、義務の全部又は一部を第三者に譲渡し、もしくは貸与、売買、名義変更、質権の設定その他の担保に供する等の処分行為を行うことはできないものとします。
              <br />
              2.
              弊社は、本サービスにかかる事業を第三者に譲渡（通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含みます）した場合には、当該譲渡に伴い、利用契約上の地位又は本規約に基づく権利義務並びに登録事項、個人情報、その他の情報を当該譲渡の譲受人に譲渡することができるものとし、ユーザーは、その譲渡に予め同意するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第３４条 解約手続（ユーザーによる解約）
            </h2>
            <p>
              1.
              ユーザーは、弊社所定の方法によって解約を通知することによって、即時に利用契約を解約することができるものとします。尚、この場合、未来日に顧客の予約がある場合などで、顧客に不利益が生じるため解約が制限されることがあります。その時は、予約日が経過し役務が提供されたのち、またはユーザーから当該顧客に連絡し自己の責任で予約取消手続を行ったのちに、解約が可能となります。また、解約時にすでに弊社に支払い済みの利用料は返還されないものとします。
              <br />
              2.
              前項の解約がなされた時、当社は、解約後すみやかに本サービスの提供を停止するものとします。また、弊社は、弊社の判断により、本サービスにおける、利用者及び利用者の顧客に関する情報を消去することができるものとします。
              <br />
              3.
              解約によって利用契約が終了した場合、利用者は利用契約の終了の日までに発生する弊社に対する債務の全額を、弊社の指示にもとづき、一括して支払うものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第３５条 解約手続（弊社による解約）
            </h2>
            <p>
              1.
              弊社は、ユーザーが次の各号のいずれかに該当する場合、事前にユーザーに催告することなく、直ちに利用契約を解除できるものとします。
              <br />
              &nbsp;1) 第12条（禁止事項）の各号に該当する行為を行った場合
              <br />
              &nbsp;2) 弊社への申告・届出内容に虚偽があった場合
              <br />
              &nbsp;3) 本サービス利用料金の支払債務の滞納があった場合
              <br />
              &nbsp;4)
              ユーザーが法人の場合で、実際に従業員や事業所等が存在せず、実質的に業務が停止していると認められる場合
              <br />
              &nbsp;5) 差押え、仮差押え、仮処分、強制執行等を受けた場合
              <br />
              &nbsp;6) 手形・小切手が不渡りとなった場合
              <br />
              &nbsp;7)
              支払いの停止があった場合、または破産、民事再生手続開始、会社更生手続開始もしくは特別清算開始の申立がなされた場合
              <br />
              &nbsp;8) 解散もしくは事業が廃止になった場合
              <br />
              &nbsp;9) 公租公課の滞納処分を受けた場合
              <br />
              &nbsp;10)
              その他本規約に違反した場合の他、ユーザーとして不適切だと弊社が判断した場合
            </p>
            <p>
              2.
              弊社は、利用契約期間中であっても、ユーザーに対し、１ヶ月前に通知をした上で、利用契約の一部または全部を解約し、終了することができます。
            </p>
            <p>
              3.
              本条による解約がなされた場合、弊社は、解約後すみやかに本サービスの提供を停止するものとします。また、その場合弊社は、弊社の判断により保存されていたユーザー及びユーザーの顧客に関するデータを消去することができるものとします。
            </p>
            <p>
              4.
              本条第1項及び第2項の規定により利用契約が解約された場合、利用者は、その利用中にかかる一切の債務について当然に期限の利益を喪失し、残存する債務全額をただちに支払うものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３６条 秘密保持</h2>
            <p>
              1.
              弊社及びユーザーは、本サービスに関連して相手方に対して秘密に取り扱うことを求めて開示した非公知の情報については、事前の書面による承諾がある場合を除いて、善良なる管理者の注意をもって管理するものとし、これを秘密に取り扱うものとします。ただし、次の各号に掲げることを証明できる情報についてはこの限りではありません。
              <br />
              &nbsp;1) 秘密情報を知得した時に、公知公用となっている情報
              <br />
              &nbsp;2)
              秘密情報を知得した後に、受領者の責によらず公知公用となった情報
              <br />
              &nbsp;3) 秘密情報を知得した時に、受領者が既に知得していた情報
              <br />
              &nbsp;4)
              秘密情報を知得した後に、受領者が秘密情報によることなく、独自に開発した情報
              <br />
              &nbsp;5)
              秘密情報を知得した後に、受領者が正当な権利を有する第三者から如何なる守秘義務も負うことなく、かつ、適法に入手した情報
              <br />
              &nbsp;6)
              秘密情報を開示者より、秘密として取り扱わない旨、指定された情報
            </p>
            <p>
              2.
              弊社及びユーザーは、相手方の秘密情報を業務上知る必要のある者であって、利用契約の条項に拘束され、これを遵守することに同意した従業員に対してのみ、秘密情報を開示することができるものとします。
            </p>
            <p>
              3.
              弊社及びユーザーは、秘密情報を保護するための管理策を講じ、業務遂行上必要な範囲を逸脱して、秘密情報を利用しないよう管理・監督するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３７条 分離可能性</h2>
            <p>
              本規約に定める条項の一部が法令上無効であるとされた場合であっても、無効とされた当該条項以外の本規約に定める条項については、引き続き有効なものとして適用されるものとします。また。無効とされた条項に関して問題が生じた場合は、ユーザー及び顧客及び弊社は、信義誠実の原則に基づき、協議をして解決するよう努めるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３８条 準拠法・管轄裁判所</h2>
            <p>
              本規約の準拠法は、日本法とします。本サービスに関連してユーザーと弊社との間で問題が生じた場合は、両者で誠意をもって協議の上解決するものとします。尚、協議によっても解決することができず、やむなく訴訟（裁判所における調停手続を含む）による場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とすることに合意します
              <br />
              <br />
              ２０２２年9月27日制定
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>別紙 メール配信機能利用規約</h2>
            <p>
              この利用条件（以下、「本利用条件」といいます。）は、弊社がYoyacooとして提供するメール配信機能（以下、本利用条件において「メール機能」といいます。）の利用の諸条件を定めるものです。以下の文書で参照する「第三提供者」には、SendGrid社が含まれ、「第三者サービス」にはSendGrid社が提供するサービスが含まれるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１条 第三者のサービス</h2>
            <p>
              1.
              本利用条件に基づいてユーザーに提供されるメール機能には、弊社にメール機能を提供する第三者（以下「第三提供者」といいます）により開発、提供及び維持されているメール機能を含みます。ユーザーが、弊社の提供するこれらのメール機能（以下「第三者サービス」といいます）にアクセスし又は使用する場合には、当該第三者サービスに関する「
              <a href="https://sendgrid.kke.co.jp/terms/">利用約款</a>」及び「
              <a href="https://sendgrid.kke.co.jp/privacypolicy/">
                プライバシーポリシー
              </a>
              」に合意しなければなりません（これらを併せて以下「第三者サービス利用約款等」といいます）。第三者サービスには、本利用条件の条項が適用されるとともに、全ての第三者サービス利用約款等の条項が適用されます。
              <br />
              2.
              本利用条件で定められていない限り、本利用条件の条項と第三者サービス利用約款等の条項に齟齬が生じた場合、第三者サービス利用約款等の条項が優先的に適用されます。そのほか全ての第三者サービス利用約款等も本利用条件の条項に準じます。
              <br />
              3.
              第三提供者は、第三者サービス及び第三者サービスを提供する為のソフトウェア、ハードウェア、テクノロジー及びそれらに対する追加、改正、更新や変更に対する全ての権利を保持します。第三提供者は、第三者サービスを提供する限り、本利用条件上規定されている利益を受けることができ、ユーザーが本利用条件の条項に違反した場合、本利用条件上の権利を行使することができます。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２条 表明、保証及び誓約</h2>
            <p>
              ユーザーは、以下の通り表明、保証し、誓約します。
              <br />
              1.
              ユーザーは、本利用条件に基づいたメール機能の利用契約を締結する法的権利と地位を有すること。
              <br />
              2.
              ユーザーは、本利用条件に基づく義務を履行し、本利用条件及び、本利用条件に基づき提供されるメール機能に関連し、ユーザーが別途締結する契約に記述されている権利や資格を許諾する法的権利と地位を有すること。
              <br />
              3.
              コンテンツ（第7条第1項で定義します）は、全て本利用条件条項に従うこと。
              <br />
              4.
              ユーザーは、本利用条件の条項及び本利用条件に基づく義務に適用される全ての法律、規則に従い、本利用条件に基づいて提供されるメール機能を使用すること。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３条 保証免責</h2>
            <p>
              1.
              本利用条件に基づいて提供されるメール機能に関する唯一の保証は、本利用条件に基づいて弊社によりユーザーに提供されると明示された保証に限られます。全ての第三者サービスは第三提供者による「現状有姿」及び「利用可能な場合」に厳格に限定して提供されており、第三者サービスについては明示か黙示かにかかわらず、また法の定めか否かを問わず、商品性に関する保証、特定目的に適合する保証、権原の保証、第三者に対する権利の非侵害の保証を含むいかなる表明及び保証を含まないものとします。
              <br />
              2.
              本サービスは高リスクアクティビティ（第7条第2項で定義します。）に利用するために設計、製造、意図されたものではありません。
              <br />
              3.
              口頭、又は書面による弊社若しくは各第三提供者による情報提供及び助言については、なんら第三提供者の代理として、保証を生じさせるものではありません。
              <br />
              4.
              弊社は、ユーザー及び本メール機能を用いて送信するメールの受信者との間に発生した紛争につき、一切責任を負いません。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第４条 補償</h2>
            <p>
              ユーザーは弊社、第三提供者、第三提供者の関係者、被用者、代理人、契約の相手方、譲受人、使用許諾人、承継人（以下、総称して「被補償者」といいます）に対する第三者からの請求があった場合、被補償者を免責し、その請求の補償をすることに同意します。かかる免責及び補償は、ユーザーが本利用条件に基づいて提供されるメール機能へのアクセス又は使用から起因した場合、及び本利用条件の違反の有無にかかわらず、かかるメール機能において電子メール又はその他の交信手段（第三者サービスによる場合を含みます）により生成され送付された内容に起因する場合、全ての損害及び費用（弁護士費用、裁判費用、損害賠償金、和解金を含みます）が対象となります。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第５条 賠償責任の制限</h2>
            <p>
              ユーザーは、本利用条件に基づいて提供されるメール機能は弊社のみが責任を負うことに同意します。第三提供者は本利用条件における責任若しくは、本利用条件に基づき提供されるメール機能（第三者サービスを含みます。）に関連する責任を負いません。本利用条件における第三提供者の責任及び、本利用条件に基づき提供されるメール機能（第三者サービスを含みます。）に関連する責任には、いかなる直接的、間接的、偶発的、特別、懲戒、又は懲罰的損害（これに限られません。）に対する責任が含まれており、契約責任、厳格責任又は不法行為責任（過失いかんを問いません。）を問いません。仮に第三提供者が、データの逸失、機会逸失、売上げ又は利益の損失、業務中断及び代替商品やメール機能の調達等を含む、かかる損害発生の可能性を事前に認識していたとしても、本条の責任の制限が適用されます。本条における損害の制限が適用法によって許されない場合には、該当する法律によって許される最大限の免責範囲が適用されるものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第６条 機密保持</h2>
            <p>
              弊社と第三提供者は本利用条件によるメール機能の使用、運用によって得た、若しくは関連するデータ、情報(以下「メール機能データ」といいます。)を収集、抜粋、編集、統合及び分析する権利を有します。弊社や第三提供者によって収集されたメール機能データは収集した者が保有し、本利用条件に基づきメール機能が提供される時点で存在する個人情報保護方針の対象となるユーザーへの報告義務なしに、合法的な目的のために使用されることがあります。ユーザーは、本利用条件に基づいて提供されるメール機能に適用されるその時点の個人情報保護方針又は本利用条件に記載されている、個人を特定しうるデータ、その他の情報の使用及び開示について承諾します。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第７条 コンテンツ</h2>
            <p>
              1.
              ユーザーは、本利用条件に基づいて提供されるメール機能に関連して、ユーザーによって提供されるデータ、情報、その他のコンテンツ（以下、総称して「コンテンツ」といいます）に関して責任を負います。ユーザーは、以下のコンテンツを提供すること、第三者に提供を許可すること、以下のコンテンツの提供を目的として本利用条件に基づいて提供されているメール機能を使用すること及び第三者への使用許諾をすることはできません。
              <br />
              &nbsp;1)
              第三者の知的財産権及び、その他の権利の侵害、不正使用、及びいかなる侵害行為
              <br />
              &nbsp;2)
              名誉毀損、未成年者に有害な内容、わいせつ、又は児童ポルノを含む場合
              <br />
              &nbsp;3)
              メール機能に支障を与えるようなウイルス又はプログラミングルーチンを含んでいる場合、又はデータや情報を不正に傍受又は収集する、あるいは、メール機能を提供するソフトウェア、ハードウェア、その他の技術を含んでいる場合
              <br />
              &nbsp;4) 情報が虚偽、誤情報、又は不正確である場合
            </p>
            <p>
              2.
              弊社及び第三提供者は、コンテンツのいかなる削除、訂正、破棄、損害、損失、あるいはバックアップの失敗について、責任を負わないものとします。
            </p>
            <p>
              3.
              弊社及び第三提供者は、コンテンツに関する違反行為があると判断した場合は、これに対する是正措置を講ずることができますが、弊社及び第三提供者は、コンテンツの正確性や潜在的な責任についてこれを審査すべき義務を負わないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第８条 使用許諾</h2>
            <p>
              ユーザーは、本利用条件に基づいて弊社及び第三提供者がメール機能を提供するために必要なすべてのコンテンツに関する権利及びライセンスを、弊社と第三提供者に許諾するものとします。ユーザーは、全てのコンテンツのバックアップを適宜適切に行うものとします。ユーザーは、弊社と第三提供者が本契約又は本契約に基づくメール機能を提供するために必要なコンテンツの使用を許可するすべての必要な権利、権原、利害、合意をユーザーが有していることを表明し保証します。
            </p>
          </section>
        </div>
      </div>
    </article>
  );
}

TermsIndex.getLayout = function getLayout(page: ReactElement) {
  return <LayoutLoginTemplate isTextLeft={true}>{page}</LayoutLoginTemplate>;
};
